import { createSelector } from 'reselect';
import { LayoutState, LayoutViewState, LayoutVisibilityState } from '../slices/layout';
import { RootState } from '../store';
import { applicationPathSelector, overrideToolSelector } from './cityView';
import { ApplicationMode, ApplicationOverrideTool } from 'types/applicationPath';

export const layoutSelector: (state: RootState) => LayoutState = (state: RootState) => state.layout;

export const layoutVisibilitySelector: (state: RootState) => LayoutVisibilityState = (state: RootState) =>
  state.layout.visibility;

export const layoutVisibilityKeySelector = createSelector(
  [layoutVisibilitySelector, (_, key: string) => key],
  (state, key) => state[key],
);

export const layoutViewSelector: (state: RootState) => LayoutViewState = (state: RootState) => state.layout.view;

export const layoutViewKeySelector = createSelector(
  [layoutViewSelector, (_, key: string) => key],
  (state, key) => state[key],
);

export const sidebarOpenSelector = createSelector([layoutSelector, applicationPathSelector, overrideToolSelector], (layout, applicationPath, overrideTool) => {
  if (applicationPath.mode === ApplicationMode.WINDOW_VIEW || overrideTool === ApplicationOverrideTool.SELECT_WINDOW_FOR_CAMERA) {
    return false;
  }

  return layout.visibility.sidebar;
});
